import React, { Component } from 'react';

import { RadioButtonGroup, TextField } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { RadioButton } from 'material-ui/RadioButton';

import * as formatter from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';
import validate from './validate';

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
  ) : (
    false
  );

class ImportantDetails extends Component {
  render() {
    const { handleSubmit } = this.props;
    // add_property is the form object from the redux-form reducer
    // TODO: when application fees is sorted out this will need to be added back in. Don't remove this alberto
    //const showApplicationFeeQuestions = (add_property && add_property.charge_application_fee === "true");
    //const showApplicationFeeAmount = (add_property && add_property.deposit_as_fee === "false");
    const showApplicationFeeQuestions = false;
    const showApplicationFeeAmount = false;

    return (
      <div>
        <h3 style={{ textAlign: 'center', marginBottom: '5px' }}>Important Details</h3>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>Do you own this property?</h5>
            <Field
              name="third_party_manager"
              component={RadioButtonGroup}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="false"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex' }}
              />
              <RadioButton
                value="true"
                label="No"
                style={{
                  width: '70px',
                  display: 'inline-flex',
                  float: 'right',
                }}
              />
            </Field>
            <Field name="third_party_manager" component={renderError} />

            <h5
              style={{
                textAlign: 'center',
                marginBottom: '15px',
                marginTop: '20px',
              }}
            >
              Do you collect a security deposit or last months rent?
            </h5>
            <Field
              name="uses_security_deposit"
              component={RadioButtonGroup}
              style={{ width: '300px', textAlign: 'center', margin: 'auto' }}
            >
              <RadioButton
                value="true"
                label="Security Deposit"
                style={{ display: 'inline-flex', width: '150px' }}
              />
              <RadioButton
                value="false"
                label="Last Months Rent"
                style={{
                  display: 'inline-flex',
                  float: 'right',
                  width: '150px',
                }}
              />
            </Field>
            <Field name="uses_security_deposit" component={renderError} />

            {/*<h5 style={{textAlign: 'center', marginBottom: '15px'}}>Would you like to charge an application fee?</h5>
            <Field name="charge_application_fee" component={RadioButtonGroup} style={{width: '187px', margin: 'auto'}}>
              <RadioButton
                value="true"
                label="Yes"
                style={{width: '102px', display: 'inline-flex'}}/>
              <RadioButton
                value="false"
                label="No"
                style={{width: '70px', display: 'inline-flex', float: 'right'}}/>
            </Field>
            <Field name="charge_application_fee" component={renderError}/>*/}

            {showApplicationFeeQuestions && (
              <div>
                <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
                  Would you like the application fee to go towards the deposit?
                </h5>
                <Field
                  name="application_fee_towards_deposit"
                  component={RadioButtonGroup}
                  style={{ width: '187px', margin: 'auto' }}
                >
                  <RadioButton
                    value="true"
                    label="Yes"
                    style={{ width: '102px', display: 'inline-flex' }}
                  />
                  <RadioButton
                    value="false"
                    label="No"
                    style={{
                      width: '70px',
                      display: 'inline-flex',
                      float: 'right',
                    }}
                  />
                </Field>
                <Field name="application_fee_towards_deposit" component={renderError} />

                <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
                  Would you like to collect the entire deposit as the application fee?
                </h5>
                <Field
                  name="deposit_as_fee"
                  component={RadioButtonGroup}
                  style={{ width: '187px', margin: 'auto' }}
                >
                  <RadioButton
                    value="true"
                    label="Yes"
                    style={{ width: '102px', display: 'inline-flex' }}
                  />
                  <RadioButton
                    value="false"
                    label="No"
                    style={{
                      width: '70px',
                      display: 'inline-flex',
                      float: 'right',
                    }}
                  />
                </Field>
                <Field name="deposit_as_fee" component={renderError} />
              </div>
            )}

            {showApplicationFeeAmount && (
              <div>
                <Field
                  name="application_fee"
                  component={TextField}
                  hintText="Application Fee Amount"
                  fullWidth
                  style={{
                    fontSize: '14px',
                    margin: '20px auto 20px auto',
                    display: 'block',
                    width: '200px',
                  }}
                  {...formatter.currencyMask}
                />
                <Field name="application_fee_nan" component={renderError} />
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
}

ImportantDetails = connect(store => {
  return { add_property: store.form.add_property.values };
})(ImportantDetails);

ImportantDetails = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ImportantDetails);

export default ImportantDetails;
